import {
  CHANGE_SECTIONS_CONTENT_MODE_ACTION,
  CHANGE_VIEW_STATE,
  CLEAR_VIEW_DATA,
  CLEAR_VIEW_STATE,
  SELECT_OPTION_ACTION,
  SELECT_OPTION_STATE_KEY,
  SELECT_SECTION_ACTION,
  SET_PAGINATION_ACTION,
  SET_PAGINATION_KEY,
  SET_SEARCH_BOX_ACTION,
  SET_SEARCH_BOX_KEY,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from './types';

export const selectSection = (
  active_section: ViewActionPayload,
): ViewAction => {
  return {
    type: SELECT_SECTION_ACTION,
    dataKey: 'activeSectionID',
    value: active_section,
  };
};

export const changeContentMode = (mode: ViewActionPayload): ViewAction => {
  return {
    type: CHANGE_SECTIONS_CONTENT_MODE_ACTION,
    dataKey: 'sectionsContentMode',
    value: mode,
  };
};

export const changeViewStateAction = (
  payload: ViewActionPayload,
): ViewAction => {
  return {
    type: CHANGE_VIEW_STATE,
    value: payload,
  };
};

export const selectOption = (
  selectBoxID: string,
  value: ViewActionPayload,
): ViewAction => {
  return {
    type: SELECT_OPTION_ACTION,
    dataKey: SELECT_OPTION_STATE_KEY,
    selectBoxID: selectBoxID,
    value: { value: value },
  };
};

export const setPagination = (
  paginatorId: string,
  value: ViewActionPayload,
): ViewAction => {
  return {
    type: SET_PAGINATION_ACTION,
    dataKey: SET_PAGINATION_KEY,
    paginatorId: paginatorId,
    value: { value: value },
  };
};

export const searchBoxKeyDown = (value: ViewActionPayload): ViewAction => {
  return {
    type: SET_SEARCH_BOX_ACTION,
    dataKey: SET_SEARCH_BOX_KEY,
    value: { value: value },
  };
};

export const clearViewState = (): ViewAction => {
  return {
    type: CLEAR_VIEW_STATE,
  };
};

export const clearViewData = (): ViewAction => {
  return {
    type: CLEAR_VIEW_DATA,
  };
};
